import * as React from "react";
import { connect } from "react-redux";
import * as router from "react-router-redux";

import _get from "lodash/get";

import * as tokens from "../modules/user/actions";
import * as userUtils from "../modules/user/utils";

import EmailAndPasswordForm from "../components/EmailAndPasswordForm";
import * as notifications from "../modules/notifications/actions";
import { noOpErrorHandlers } from "../utils/request";

class ResetPasswordContainer extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillMount() {
        this.fetchResetPasswordTokenIfAbsent(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.fetchResetPasswordTokenIfAbsent(nextProps);
    }

    fetchResetPasswordTokenIfAbsent(props) {
        if (props.loadingStatus === "absent") {
            return props
                .fetchResetPasswordToken(props.tokenId)
                .catch(err => this.handleTokenError(err));
        }
    }

    handleSubmit({ password, remember }) {
        this.props
            .resetPasswordWithToken(this.props.token.token, password)
            .then(() => this.props.navigateTo("/"))
            .catch(err => this.handleTokenError(err));
    }

    handleTokenError(err) {
        const code = _get(err, "response.data.info.errorCode", null);

        let message;
        switch (code) {
            case "usedToken":
                message =
                    "Sorry, you've already used this link. You'll need another one.";
                break;
            case "expiredToken":
                message =
                    "Uh oh, looks like the time ran out on this link. Maybe try again.";
                break;
            default:
                message =
                    "Nope. Something is definitely wrong. This link is invalid. You'll need a new one.";
                break;
        }

        this.props.notifyError(message, "exclamation-triangle");
        this.props.navigateTo("/login");
    }

    render() {
        const isLoading =
            this.props.loadingStatus === "absent" ||
            this.props.loadingStatus === "loading" ||
            this.props.isResettingPassword;

        return (
            <main>
                <EmailAndPasswordForm
                    formHeader="Reset Password"
                    instructionText="Create a new password to access your account."
                    emailAddress={
                        this.props.user && this.props.user.emailAddress
                    }
                    emailEditable={false}
                    passwordValidator={userUtils.isValidPassword}
                    isLoading={isLoading}
                    onSubmit={this.handleSubmit}
                />
            </main>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const tokenId = ownProps.match.params.tokenId;
    const token = state.entities.tokens && state.entities.tokens[tokenId];
    const user = token ? state.entities.users[token.user] : null;
    const loadingInfo = state.user.tokens[tokenId] || { status: "absent" };

    return {
        tokenId,
        token,
        user,
        loadingStatus: loadingInfo.status,
        loadingError: loadingInfo.error,
        isResettingPassword: state.user.isResettingPassword
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchResetPasswordToken: tokenId =>
            dispatch(
                tokens.fetchUserInvitationToken(
                    tokenId,
                    "PASSWORD_RESET",
                    noOpErrorHandlers
                )
            ),
        resetPasswordWithToken: (tokenId, password) =>
            dispatch(tokens.resetPasswordWithToken(tokenId, password)),
        navigateTo: url => dispatch(router.push(url)),
        notifyError: (message, icon, button) =>
            dispatch(notifications.notifyError(message, icon, button))
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ResetPasswordContainer);



// WEBPACK FOOTER //
// ./src/containers/ResetPasswordContainer.js